import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import Settings from "Data/Settings";
import * as Topics from "Data/Topics";
import * as Constants from "Data/Constants";
import { IDuckConfig, IDuckState, IRuntimeDuck } from "Data/GameState";

export class FlyingGameDuck extends PIXI.Container implements IRuntimeDuck {

    public readonly sprite: HLF.AnimatedSprite;

    public readonly config: IDuckConfig;

    public isColliding: boolean = false;

    public following?: FlyingGameDuck;

    public maxEfficiency: number = 100;

    protected _efficiency: number = 100;

    protected _energy: number;

    private animationState: "ok" | "tired";

    public constructor(pConfig: IDuckConfig, pState: IDuckState) {
        super();
        this._energy = pState.energy;
        this._efficiency = pState.efficiency
        this.name = pState.name;
        this.config = pConfig;
        this.sprite = this.addChild(new HLF.AnimatedSprite());
        this.sprite.addAnimation("flying", new HLF.SpriteAnimation(pConfig.flyingSprite.replace(/\d+$/, ''), undefined as any as string, 7, 2, 24, true, 1));
        this.sprite.addAnimation("tired", new HLF.SpriteAnimation(pConfig.flyingSprite_tired.replace(/\d+$/, ''), undefined as any as string, 7, 2, 12, true, 1));

        if (pState.efficiency === 0) {
            this.animationState = "tired";
            this.sprite.play("tired");
        }
        else {
            this.animationState = "ok";
            this.sprite.play("flying");
        }
    }

    public get energy(): number {
        return this._energy;
    }

    public set energy(pValue: number) {
        this._energy = HLF.MathUtils.clamp(pValue, 0, 100);
    }

    public get efficiency(): number {
        return this._efficiency;
    }

    public set efficiency(pValue: number) {
        this._efficiency = HLF.MathUtils.clamp(pValue, 0, this.maxEfficiency);
    }

    public update(pDeltaTime: number) {
        if (this.energy <= 15) {
            if (this.animationState !== "tired") {
                this.animationState = "tired";
                this.sprite.play("tired");
            }
        }
        else {
            if (this.animationState !== "ok") {
                this.animationState = "ok";
                this.sprite.play("flying");
            }
        }
        if (Settings.moreAnimation) {
            this.sprite.update(pDeltaTime);
        }
        else {
            this.sprite.update(0)
        }
    }

    public playTiredAnimation() {
        this.animationState = "ok";
        this.sprite.play("tired");
    }
}